import { useState, useEffect } from "react";
import { notifications } from "@mantine/notifications";
import {
  getPlayerCharacters,
  putActiveCharacter,
} from "../requests/playerCharacter";

const useProfile = ({ currentUser, refetchCurrentUser }) => {
  const [characters, setCharacters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const chars = await getPlayerCharacters();
        setCharacters(chars);
      } catch (err) {
        notifications.show({
          title: "Error",
          message: "Could not load profile.",
          color: "red",
        });
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  const activateCharacter = async (id) => {
    try {
      const updated = await putActiveCharacter(id);
      notifications.show({
        title: "Character Activated",
        message: `You're now playing as ${updated.activeCharacter?.name}.`,
        color: "green",
      });
      await refetchCurrentUser();
    } catch {
      notifications.show({
        title: "Error",
        message: "Could not activate character.",
        color: "red",
      });
    }
  };

  return {
    characters,
    loading,
    activateCharacter,
  };
};

export default useProfile;
